import { useDrop } from 'react-dnd';

import { useDndRef } from '@iconik-io/shared-lib/src/react/hooks/use_dnd_ref';

import DraggableTypes from '../../constants/draggable_types';
import type { FCC } from '../../types/common';

type Props = {
  onDrop: () => void;
};

const UngroupedSavedSearch: FCC<Props> = (props) => {
  const [, dropRef] = useDrop(
    () => ({
      accept: DraggableTypes.SAVED_SEARCH,
      drop: () => {
        props.onDrop();
      },
    }),
    [props.onDrop],
  );

  const dropTargetRef = useDndRef(dropRef);

  return <div ref={dropTargetRef}>{props.children}</div>;
};

export default UngroupedSavedSearch;
